<template>
  <div class="product-page" :class="{ 'loading': isLoading }">
    <v-loading :is-loading="isLoading" :circle-position="'top'" :color="'white'"></v-loading>
    <section class="product-page__product-container">
      <div class="image-container">
        <p class="sell-hit" :class="{ 'show-off': attribute == null || attribute == '' }">{{ attribute }}</p>
        <swiper-slider :images="images"></swiper-slider>
      </div>
      <div class="product-main-info">
        <p class="product-main-info__articul">Арт. {{ articul }}</p>
        <h1 class="product-main-info__name">{{ name }}</h1>
        <p class="product-main-info__brand">Бренд: {{ brand }}</p>
        <div class="product-main-info__buttons">
          <button class="product-main-info__button" @click="catalogRequest">Запросить каталог</button>
          <button class="product-main-info__button" @click="sampleRequest">Запросить образец</button>
        </div>
        <div class="product-main-info__bottom">
          <p class="product-main-info__shipment"><span>КРАТНОСТЬ ОТГРУЗКИ:</span><br>
            {{ multiplicity }} {{ unit }}.</p>
          <p class="product-main-info__price">{{ price }} ₽</p>
          <p v-if="is_only_order" class="product-main-info__status">Поставляется под заказ</p>
          <p v-else class="product-main-info__status">
            {{ availability > 0 ? `В наличии ${availability}` : `Нет в наличии` }}
          </p>
          <div class="product-main-info__functions">
            <amount-block class="product-main-info__amount-block" :amount="amount"
              @amountChange="amountChange"></amount-block>
            <button class="product-main-info__add-btn" :class="{ 'added': isAdded }" @click="addGoodToCart">
              <span>В корзину</span>
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2333_22907)">
                  <path
                    d="M8.02678 7.25711L8.02935 7.27163H8.04409H20.7969C21.0021 7.27163 21.1967 7.36362 21.327 7.52242C21.4571 7.68122 21.5093 7.88996 21.4692 8.09134L21.0271 10.3062C20.962 10.6321 20.6758 10.8577 20.3556 10.8577C20.3111 10.8577 20.2661 10.8533 20.2207 10.8443C19.8494 10.7701 19.6085 10.4091 19.6825 10.0379L19.9568 8.66374L19.961 8.64272H19.9395H18.1609H18.1448L18.1433 8.65873L17.6586 14.0727L17.6569 14.0918H17.6761H17.7059C18.3825 14.0918 18.9697 13.6103 19.1022 12.9466L19.0849 12.9432L19.1022 12.9466C19.1762 12.5753 19.5373 12.3346 19.9085 12.4086C20.2798 12.4827 20.5208 12.8437 20.4466 13.2149L20.4639 13.2184L20.4466 13.215C20.1868 14.5175 19.034 15.4629 17.7059 15.4629H9.49703H9.47608L9.47972 15.4835L9.73721 16.9418L9.7391 16.9525L9.74948 16.9556C10.3741 17.1428 10.8746 17.6192 11.0949 18.2286L11.0991 18.2402H11.1115H15.2245H15.2368L15.241 18.2286C15.5272 17.4367 16.2864 16.8691 17.1758 16.8691C18.3098 16.8691 19.2324 17.7918 19.2324 18.9258C19.2324 20.0599 18.3098 20.9824 17.1758 20.9824C16.2864 20.9824 15.5272 20.4149 15.241 19.6229L15.2368 19.6113H15.2245H11.1115H11.0991L11.0949 19.6229C10.8087 20.4149 10.0495 20.9824 9.1603 20.9824C8.0262 20.9824 7.10366 20.0599 7.10366 18.9258C7.10366 18.0803 7.61669 17.3524 8.34796 17.0368L8.36072 17.0313L8.35831 17.0176L6.35385 5.66869L6.35238 5.66038L6.34498 5.65632L3.87429 4.30473L3.87429 4.30473C3.54209 4.12303 3.42011 3.70648 3.60181 3.37429C3.78351 3.04209 4.20006 2.92011 4.53225 3.10181L7.29916 4.61545L7.30759 4.60003L7.29916 4.61545C7.4818 4.71534 7.60913 4.89275 7.64528 5.09761L8.02678 7.25711ZM13.4668 8.6603V8.64272H13.4492H11.5909H11.5717L11.5734 8.66187L12.0583 14.0758L12.0597 14.0918H12.0758H13.4492H13.4668V14.0742V8.6603ZM16.4977 19.0163L16.497 19.0163L16.4977 19.0211C16.5443 19.3541 16.8301 19.6113 17.1758 19.6113C17.5538 19.6113 17.8613 19.3038 17.8613 18.9258C17.8613 18.5478 17.5538 18.2402 17.1758 18.2402C16.8301 18.2402 16.5443 18.4976 16.4977 18.8305L16.497 18.8304L16.4977 18.8352C16.5016 18.8653 16.5044 18.8953 16.5044 18.9258C16.5044 18.9563 16.5016 18.9864 16.4977 19.0163ZM8.29238 8.64272H8.27143L8.27507 8.66336L9.23129 14.0773L9.23386 14.0918H9.2486H10.6639H10.6831L10.6814 14.0727L10.1965 8.65873L10.1951 8.64272H10.179H8.29238ZM16.2642 14.0918H16.2803L16.2817 14.0758L16.7665 8.66187L16.7682 8.64272H16.749H14.8555H14.8379V8.6603V14.0742V14.0918H14.8555H16.2642ZM8.47475 18.9258C8.47475 19.3038 8.78214 19.6113 9.1603 19.6113C9.53819 19.6113 9.84571 19.3038 9.84571 18.9258C9.84571 18.5478 9.53833 18.2402 9.1603 18.2402C8.78214 18.2402 8.47475 18.5478 8.47475 18.9258Z"
                    fill="white" stroke="#424F60" stroke-width="0.0351562" />
                </g>
                <defs>
                  <clipPath id="clip0_2333_22907">
                    <rect width="18" height="18" fill="white" transform="translate(3.5 3)" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
    <section class="product-description">
      <div class="product-description__header">
        <p class="product-description__header__item">ОПИСАНИЕ</p>
      </div>
      <p class="product-description__text">{{ text }}</p>
      <div class="product-description__container">
        <div v-for="desc in  descriptions " class="description-item">
          <p class="description-item__label">{{ desc.label }}</p>
          <div class="description-item__line"></div>
          <p class="description-item__value">{{ desc.value }}</p>
        </div>
      </div>
    </section>
    <custom-header :title="'Аналогичные товары'"></custom-header>
    <!-- <div class="good-container">
      <goods-slider :goods="goods" @addedToCart="(id) => onAddedToCart(goods, id)"
        @amount-change="(id, amount) => onAmountChange(goods, id, amount)"></goods-slider>
    </div> -->
    <p class="block-placeholder">Аналогичные товары не найдены</p>
    <custom-header :title="'Сопутствующие товары'"></custom-header>
    <div v-if="relatedGoods.length > 0" class="good-container">
      <goods-slider :goods="relatedGoods" @addedToCart="(id) => onAddedToCart(relatedGoods, id)"
        @amount-change="(id, amount) => onAmountChange(relatedGoods, id, amount)"></goods-slider>
    </div>
    <p v-else class="block-placeholder">Сопутствующие товары не найдены</p>
  </div>
</template>

<script>
import ProductCard from '../components/ProductCard.vue';
import CustomHeader from '../components/CustomHeader.vue';
import AmountBlock from '../components/AmountBlock.vue'
import SwiperSlider from '../components/SwiperSlider.vue'
import vLoading from '../components/v-loading.vue';
import GoodsSlider from '../components/GoodsSlider.vue';

import { mapWritableState, mapActions } from 'pinia';
import { useMarketingRequests } from '../stores/marketingRequests';
import { useAddedGoods } from '../stores/addedGoods'
import { useBreadcrumbs } from '../stores/breadcrumbs';

import { serverRequest } from '../api/request';

export default {
  name: 'ProductView',
  components: {
    ProductCard,
    CustomHeader,
    AmountBlock,
    SwiperSlider,
    vLoading,
    GoodsSlider
  },

  props: {
    id: {
      type: String,
      default() {
        return '0'
      }
    },
  },

  data() {
    return {
      isLoading: false,
      isAdded: false,
      descriptions: [
        // {
        //   label: 'Диаметр фрезы, мм',
        //   value: '4'
        // },
        // {
        //   label: 'Диаметр фрезы, мм',
        //   value: '4'
        // },
        // {
        //   label: 'Диаметр фрезы, мм',
        //   value: '4'
        // },
      ],
      goods: [
        {
          id: 23,
          amount: 1,
          articul: 'FBK0500219',
          name: "Корончатое сверло (фреза кольцевая) Ø13 L=30/63 мм №102 WELDON19 HSS M2 ТМ ПрофОснастка",
          price: '1496',
          images: []
        },
        {
          id: 22,
          amount: 1,
          articul: 'FBK0500219',
          name: "Корончатое сверло (фреза кольцевая) Ø13 L=30/63 мм №102 WELDON19 HSS M2 ТМ ПрофОснастка",
          price: '1496',
          images: []
        },
      ],
      relatedGoods: [],
      images: [],
      amount: 1,
      brand: '',
      articul: '',
      price: 0,
      name: '',
      multiplicity: '',
      availability: 0,
      unit: '',
      text: '',
      attribute: '',
      is_only_order: false,
      analogsGoods: [],
      relatedGoods: []
    }
  },

  beforeMount() {
    this.getData()
    this.checkProducts()
  },

  created() {
    this.$watch(
      () => this.id,
      (toParams, previousParams) => {
        this.getData()
        this.checkProducts()
      }
    )
  },

  computed: {
    ...mapWritableState(useMarketingRequests, { storeGoodId: 'id' }),
    ...mapWritableState(useMarketingRequests, { storeName: 'name' }),
    ...mapWritableState(useAddedGoods, { storeCardGoods: 'cartGoods' }),
    ...mapWritableState(useBreadcrumbs, { storeBreadcrumbs: 'breadcrumbs' }),
  },

  methods: {
    ...mapActions(useAddedGoods, { storeSetAmount: 'setAmount' }),
    ...mapActions(useAddedGoods, { storeDeleteGood: 'deleteGood' }),

    amountChange(amount) {
      this.amount = amount

      if (this.isAdded) {
        this.storeSetAmount(this.id, amount)
      }

      this.checkProducts()
    },

    catalogRequest() {
      this.$router.push({ 'name': 'marketingPages', params: { page: 'CatalogRequest' } })
    },

    sampleRequest() {
      this.storeGoodId = this.id
      this.storeName = this.name
      this.$router.push({ 'name': 'marketingPages', params: { page: 'SampleRequest' } })
    },

    addGoodToCart() {
      if (this.isAdded) {
        this.storeDeleteGood(this.id)
        this.isAdded = false
      }
      else {
        let newGood = {
          id: this.id,
          name: this.name,
          articul: this.articul,
          brand: this.brand,
          multiplicity: this.multiplicity,
          unit: this.unit,
          amount: this.amount,
          price: this.price,
          images: this.images
        }
        this.isAdded = true

        this.storeCardGoods.push(newGood)
      }

      this.checkProducts()
    },

    onAddedToCart(goods, id) {
      let good = goods.find((item) => item.id === id)
      good.added = !good.added

      this.checkProducts()
    },

    onAmountChange(goods, id, amount) {
      let good = goods.find((item) => item.id === id)
      good.amount = amount

      this.checkProducts()
    },


    checkProducts() {
      let cartGood = this.storeCardGoods.find((item) => item.id == this.id)

      if (cartGood != undefined) {
        this.isAdded = true
        this.amount = cartGood.amount
      }
      else {
        this.isAdded = false
      }

      for (let good of this.goods) {
        let cartGood = this.storeCardGoods.find((item) => item.id == good.id)

        if (cartGood != undefined) {
          good.added = true
          good.amount = cartGood.amount
        }
        else {
          good.added = false
        }
      }
    },

    async getData() {
      this.isLoading = true

      let formData = {
        id: this.id,
      }

      let result = await serverRequest('POST', 'json', 'get_good_info', formData)

      if (result != 'error' && result != 'unathorized') {
        this.brand = result.data.brand
        this.name = result.data.name
        this.articul = result.data.articul
        this.price = parseInt(result.data.price)
        this.availability = result.data.availability
        this.multiplicity = result.data.multiplicity
        this.unit = result.data.unit
        this.images = result.data.images
        this.text = result.data.text
        this.descriptions = result.data.descriptions
        this.attribute = result.data.attribute
        this.relatedGoods = result.data.related_products

        // let newBreadcrumb = {
        //   path: 'product',
        //   name: this.name
        // }
        // this.breadcrumbList.push(newBreadcrumb)
      }
      else {
        //alert('Ошибка запроса')
      }

      this.storeBreadcrumbs = [
        {
          path: 'categories',
          name: 'Каталог'
        },
        {
          path: 'product',
          name: this.name,
          params: {
            id: this.id
          },
        },
      ]

      this.isLoading = false
    }
  }
}
</script>


<style lang="scss">
.product-page {
  min-width: 0;

  @extend %white-bg-block;

  padding: 24px;

  width: 100%;

  position: relative;

  &.loading {
    pointer-events: none;
  }

  &__product-container {
    display: flex;
    column-gap: 40px;

    .image-container {
      .sell-hit {
        padding: 4px 12px;
        border-radius: 29px;
        background-color: var(--primary);

        @extend %text-small;
        color: var(--bw6);

        white-space: nowrap;

        width: fit-content;

        &.show-off {
          opacity: 0;
          visibility: hidden;
          height: 28px;
        }
      }
    }
  }

  .product-main-info {
    width: 100%;

    &__articul {
      @extend %text-regular;
      color: var(--bw3);
    }

    &__name {
      margin-top: 18px;

      @extend %H2;
      color: var(--bw1);

      min-height: 112px;

      max-width: 400px;
    }

    &__brand {
      @extend %text-regular;

      color: var(--bw3);

      margin-top: 35px;
    }

    &__buttons {
      margin-top: 19px;

      display: flex;
      align-items: center;
      column-gap: 12px;
    }

    &__button {
      padding: 6px 12px;

      @extend %text-regular;
      color: var(--bw1);

      border-radius: 6px;

      background-color: var(--bw4);
    }

    &__bottom {
      margin-top: 24px;

      padding-top: 16px;

      border-top: 1px solid var(--bw3);

      max-width: 500px;
    }

    &__shipment {

      span {
        text-transform: uppercase;
        @extend %text-medium;
      }

      @extend %text-medium;
      color: var(--blue);
    }

    &__price {
      margin-top: 12px;

      @extend %H2;
      color: var(--primary);
    }

    &__status {
      margin-top: 8px;

      @extend %text-medium;
      color: var(--blue);
    }

    &__functions {
      margin-top: 16px;

      display: flex;
      align-items: center;
      column-gap: 16px;
    }

    &__amount-block {
      padding: 12px;
    }

    &__add-btn {
      @extend %button;

      display: flex;
      justify-content: center;
      column-gap: 12px;

      padding: 12px 16px;

      width: 100%;
      max-width: 250px;

      user-select: none;

      transition: background-color .3s;

      &.added {
        background-color: var(--primary-bg);
      }
    }
  }

  .product-description {
    margin-top: 48px;

    &__header {
      &__item {
        padding: 12px 32px;

        @extend %text-small;
        color: var(--bw6);

        background-color: var(--bw1);

        width: fit-content;

        border-radius: 6px 6px 0px 0px;

        text-transform: uppercase;
      }
    }

    &__text {
      padding: 24px 0;

      border-top: 1px solid var(--bw4);
      border-bottom: 1px solid var(--bw4);

      @extend %text-small;
      color: var(--bw0);
    }

    &__container {
      display: grid;

      margin-top: 36px;

      width: 100%;

      grid-template-columns: repeat(2, 590px);
      justify-content: space-between;
      row-gap: 8px;
    }

    .description-item {
      display: flex;
      column-gap: 18px;

      &__label {
        @extend %text-small;
        color: var(--bw0);
      }

      &__line {
        flex: 1 0;
        border-bottom: 1px solid var(--bw4);
      }

      &__value {
        @extend %text-small;
        color: var(--bw0);

        position: relative;

        min-width: 80px;

        text-align: right;

        &::after {
          content: "";

          display: block;

          height: 1px;
          width: 80px;

          position: absolute;

          right: 0;
          bottom: 0;

          background-color: var(--bw4);
        }
      }
    }
  }

  .custom-header {
    margin-top: 40px;

    &:not(:first-of-type) {
      margin-top: 24px;
    }
  }

  .block-placeholder {
    margin-top: 32px;

    @extend %text-medium;

    padding-bottom: 100px;
  }
}

@media screen and (max-width: 1600px) {
  .product-page {
    .product-main-info {
      &__bottom {
        max-width: 100%;
      }
    }

    .product-description {
      &__container {
        grid-template-columns: 1fr;
        max-width: 590px;
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .product-page {
    padding: 0;

    &__product-container {
      flex-direction: column;
    }

    .product-main-info {
      &__articul {
        display: none;
      }

      &__name {
        max-width: 100%;
        min-height: 0;
      }

      &__brand {
        margin-top: 8px;
      }

      &__functions {
        flex-direction: row-reverse;
      }

      &__add-btn {
        width: 100%;
        max-width: 100%;
      }
    }

    .product-description {
      &__container {
        max-width: 350px;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .product-page {
    .product-main-info {
      &__buttons {
        flex-wrap: wrap;
        row-gap: 16px;
      }

      &__button {
        padding: 6px;
        width: auto;
        flex-grow: 1;
        white-space: nowrap;
      }
    }

    .product-description {
      &__container {
        max-width: 100%;
      }
    }
  }
}
</style>